<template>
  <div id="simulator" :class="getClassName('simulator')" v-if="item.is_simulator">
    <h2 :class="getClassName('simulator__title')">シミュレーションをしてみる</h2>
    <p :class="getClassName('simulator__comment')">
      生地と選んだパーツがシミュレーション画面に表示されます。
      <br class="sp" />
      色・柄の組み合わせのチェックにご活用ください。
    </p>
    <p :class="['txtRed', getClassName('simulator__comment--red')]">
      こちらで選んだ商品はカートに反映されません
    </p>

    <div class="simulator__wrapper">
      <div :class="getClassName('simulator__container')">
        <div :class="getClassName('simulator__canvas')">
          <h3 :class="getClassName('simulator__summary')">シミュレーション画面</h3>
          <div :class="getClassName('simulator__images')">
            <v-img
              :class="['simulator__image--main', getClassName('simulator__image')]"
              :src="getMainImage"
              contain
              :width="media ? (200 / 280) * 100 + '%' : 380"
              :height="media ? undefined : 380"
              :aspect-ratio="media ? 200 / 200 : 380 / 380"
              v-if="getMainImage"
            />
            <v-img
              :class="['simulator__image--sub', getClassName('simulator__image')]"
              :src="getSubImage"
              contain
              :width="media ? (200 / 280) * 100 + '%' : 380"
              :height="media ? undefined : 380"
              :aspect-ratio="media ? 200 / 200 : 380 / 380"
              v-if="getSubImage"
            />
          </div>
        </div>

        <div class="simulator__controll" v-if="!media">
          <!-- <h3 class="simulator__caption">カラー</h3>
          <SelectColors class="simulator__select" :items="[item]" :media="media" simulation v-model="main" /> -->
          <template v-for="category in this.item.parts_categories">
            <template v-if="isSimulator(category.items)">
              <h3 class="simulator__caption" :key="'caption' + category.id">パーツ（{{ category.name }}）</h3>
              <SelectColors
                class="simulator__select"
                :key="category.id"
                :items="category.items"
                :media="media"
                simulation
                v-model="sub"
                v-if="item.is_simulator"
              />
            </template>
          </template>
        </div>
        <div class="simulator__controll--sp" v-else>
          <ul class="simulator__tabs">
            <!-- <li class="simulator__tab">
              <label :class="getTabClass(`item-${item.id}`)">
                生地カラー
                <input type="radio" :value="`item-${item.id}`" v-model="controll" v-show="false" />
              </label>
            </li> -->
            <template v-for="category in this.item.parts_categories">
              <li class="simulator__tab" :key="`${uuid}-${category.id}`" v-if="isSimulator(category.items)">
                <label :class="getTabClass(`category-${category.id}`)" :for="`${uuid}-${category.id}`">
                  {{ category.name }}
                  <input
                    type="radio"
                    :id="`${uuid}-${category.id}`"
                    :value="`category-${category.id}`"
                    v-model="controll"
                    v-show="false"
                  />
                </label>
              </li>
            </template>
          </ul>
          <!-- <SelectColors
            class="simulator__select--sp"
            :items="[item]"
            :media="media"
            simulation
            v-model="main"
            v-show="`item-${item.id}` === controll"
          /> -->
          <template v-for="category in this.item.parts_categories">
            <SelectColors
              class="simulator__select--sp"
              :key="category.id"
              :items="category.items"
              :media="media"
              simulation
              v-model="sub"
              v-if="item.is_simulator"
              v-show="`category-${category.id}` === controll"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import getClassName from '../../_mixins/getClassName';

import SelectColors from './SelectColors';

export default {
  mixins: [getClassName],
  components: {
    SelectColors,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    const uuid = uuidv4();
    const partsColors = this.item.parts_categories
      .flatMap((category) => category.items)
      .flatMap((item) => item.colors)
      .filter((color) => color.simulation_image);
    return {
      uuid: uuid,
      main: {
        item_color_id: this.item.colors.length > 0 ? this.item.colors[0].id : null,
      },
      sub: {
        item_color_id: partsColors.length !== 0 ? partsColors[0].id : null,
      },
      partsColors: partsColors,
      // controll: `item-${this.item.id}`,
      controll: `category-${this.item.parts_categories[0].id}`,
    };
  },
  computed: {
    getMainImage() {
      if (this.main.item_color_id === null) return false;
      const [color] = this.item.colors.filter((color) => color.id === this.main.item_color_id);
      return color.simulation_image;
    },
    getSubImage() {
      if (this.sub.item_color_id === null) return false;
      const [color] = this.partsColors.filter((color) => color.id === this.sub.item_color_id);
      return color.simulation_image;
    },
    getTabClass() {
      return (id) =>
        id === this.controll ? 'simulator__action simulator__action--active' : 'simulator__action';
    },
    isSimulator() {
      return (items) => items.some((item) => item.is_simulator);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/mixins';

.simulator {
  background: #f6f6f6;
  width: 100%;
  padding: 40px 0 20px;
  margin-top: 35px;
  &--sp {
    background: transparent;
    width: 87.5%;
    padding: 23px 0 0;
    border-top: solid 1px currentcolor;
    margin: 23px auto 0;
  }
  &__title {
    @include title;
    font-size: 1.8rem;
    text-align: center;
    &--sp {
      font-size: 1.3rem;
    }
  }
  &__comment {
    margin-top: 5px;
    text-align: center;
    &::before {
      content: '※';
    }
    &--sp {
      margin-top: 15px;
      font-size: 0.8rem;
      &::before {
        content: none;
      }
    }
    &--red {
      margin-top: 5px;
      text-align: center;
      &::before {
        content: '※';
      }
      &--sp {
        margin-top: 10px;
        font-size: 0.8rem;
      }
    }
  }
  &__container {
    width: 1000px;
    margin: 20px auto 30px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    &--sp {
      width: 100%;
      margin-top: 20px;
      display: block;
    }
  }
  &__canvas {
    background: #fff;
    box-shadow: 2px 2px 0px 0px rgba(0, 0, 0, 0.2);
    flex: 0 0 auto;
    &--sp {
      background: transparent;
      box-shadow: none;
      display: flex;
      flex-flow: column nowrap;
    }
  }
  &__summary {
    padding: 16.5px 0;
    font-size: 1.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
      content: '';
      width: 13px;
      height: 0;
      border-top: solid 1px currentcolor;
      margin: 0 0.5em;
      display: block;
    }
    &--sp {
      padding: 0;
      margin-top: 5px;
      font-size: 0.8rem;
      order: 2;
      &::before,
      &::after {
        width: 8px;
      }
    }
  }
  &__images {
    border-style: solid;
    border-width: 0 10px 10px;
    border-color: transparent;
    position: relative;
    &--sp {
      width: 100%;
      border: none;
      order: 1;
    }
  }
  &__image {
    margin: 0 auto;
    &--sub {
      position: absolute;
      top: 0;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, 0);
    }
  }
  &__controll {
    flex: 0 0 550px;
    &--sp {
      margin-top: 20px;
    }
  }
  &__caption {
    color: $color__title;
    font-size: 1.3rem;
    line-height: 1;
    &:not(:first-of-type) {
      margin-top: 30px;
    }
  }
  &__tabs {
    width: 100%;
    margin-bottom: -1px;
    display: flex;
    overflow: auto;
  }
  &__tab {
    flex: 1;
  }
  &__tab:not(:first-child) {
    margin-left: -1px;
  }
  &__action {
    background: #f2f2f2;
    height: 100%;
    min-height: 36px;
    padding: 0 9px;
    border: solid 1px rgba(21, 21, 21, 0.5);
    border-bottom-color: currentcolor;
    border-radius: 5px 5px 0 0;
    box-sizing: border-box;
    color: $color__title;
    font-size: 0.8rem;
    letter-spacing: 0;
    line-height: calc(1em + 5px);
    display: flex;
    justify-content: center;
    align-items: center;
    &--active {
      background: #fff;
      border-color: currentcolor;
      border-bottom: none;
      position: relative;
      z-index: 1;
    }
  }
  &__select {
    margin-top: 10px;
    &--sp {
      background: #fff;
      padding: 19px;
      border: solid 1px currentcolor;
    }
  }
}
</style>

<style lang="scss">
.simulator__select {
  .colors {
    &__items {
      width: calc(100% + 16px);
      margin: -8px;
    }
    &__item {
      margin: 8px;
    }
  }
}
</style>
